// Pages/CLIRegister.jsx
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import axios from '../Intercepter/APiClient';

function CLIRegister() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', password: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/cli/register', form);
      alert(res.data.message);
      navigate('/');
    } catch (err) {
      alert('Registration failed.');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow-md space-y-4 w-full max-w-md">
        <h2 className="text-xl font-bold">📝 Create CLI Account</h2>
        <input type="text" className="border p-2 w-full" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Name" required />
        <input type="email" className="border p-2 w-full" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Email" required />
        <input type="password" className="border p-2 w-full" value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Password" required />
        <button type="submit" className="bg-green-600 text-white w-full p-2 rounded">Register</button>
        <div className="text-center">
          <button onClick={() => navigate(-1)} className="text-blue-500 underline">← Back to Login</button>
        </div>
      </form>
    </div>
  );
}

export default CLIRegister;
